export default __webpack_public_path__ + "static/media/bar.3be23d77.svg";